import { interpret } from '@fingermarkglobal/utilities';
import { createLoyaltyPossibleRedemptionsMachine } from './machines/loyalty-possible-redemptions';

const doLoyaltyPossibleRedemptions = ({
  transition = null,
  token,
  transactionId,
  payload,
  promoId,
}) => {
  const machine = createLoyaltyPossibleRedemptionsMachine({
    token,
    transactionId,
    payload,
    promoId,
  });

  const { instance: loyaltyPossibleRedemptionsMachine } = interpret({
    name: 'loyaltyPossibleRedemptionsMachine',
    machine,
    transition,
  });

  return { loyaltyPossibleRedemptionsMachine };
};

export { doLoyaltyPossibleRedemptions };
